import React, {useState} from "react";
import {AuthActions, uiActions, Navbar as Leap4Navbar, MuiIcons, ADTE_LOGO_SMALL_URL} from "@leap4/frontend"
import {connect} from "react-redux";
import {useLocation} from "react-router-dom";
import "./Navbar.module.css";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router";
import {GlobalState} from "../../../types/globalStateType";
import {urlsService} from "../../Routing/urlsService";

const { Logout } = MuiIcons;

const showSideBar = uiActions.showSidebar

function _Navbar(props: any) {
    const dispatch = useDispatch();
    const history = useHistory()
    const location = useLocation();
    const [bIsSidebarOpen, SetSideBarOpenState] = useState(false);
    const logoutUrl = process.env.REACT_APP_BACKEND_BASE_URL + '/app/logout'
    const links = [
        {text: "Home", link: urlsService.tasks()},
        {text: "Create Task", link: "/create"},
    ];

    const logoImageUrl = ADTE_LOGO_SMALL_URL;

    return (
        <Leap4Navbar
            bIsSidebarOpen={bIsSidebarOpen}
            handleDrawerClose={() => SetSideBarOpenState(false)}
            handleDrawerOpen={() => SetSideBarOpenState(true)}
            auth={{isAuthenticated: true}} ui={{nSidebarWidth: 240, nNavbarHeight: 78}}
            location={location.pathname} links={links}
            updateCheckedToFather={(checked: boolean) => {
                props.handleCheckChange(checked)
            }}

            title={"Tasks Management"} logoImageUrl={logoImageUrl}
            logout={{
                text: "Logout",
                action: async () => await AuthActions.logout(dispatch, history, logoutUrl),
                icon: <Logout/>
            }}
        />
    );
}

const mapStateToProps = (state: Partial<GlobalState>) => ({
    auth: state.auth,
    ui: state.ui,
});

export const Navbar = connect(mapStateToProps, {showSideBar})(_Navbar);
